<template>
  <home></home>
</template>

<script>
import Home from '../components/home/index';
export default { components: { Home } };
</script>
